import { IFetchSODConflictsBody } from "../../../common/SODUtils/SODconstants";
import { IOfficeItemProps } from "../../../components/OfficesList/module/constants";
import {
  IBREntitlementsItem,
  IBRItem,
  IBRRequestAndItem,
  IBRRequestItem,
  IEntitlementItem,
  IEntitlementsAndBRItem,
  IEntitlementsBRItem,
  IRequestBR,
  IUserItem,
} from "../../../models/Entitlements";

export const actionTypes = {
  SELECT_OFFICE: "SELECT_OFFICE",
  MODIFY_SELF_SELECTED: "MODIFY_SELF_SELECTED",
  MODIFY_DELEGATOR: "MODIFY_DELEGATOR",
  MODIFY_SHOW_ADVANCED_FILTER: "MODIFY_SHOW_ADVANCED_FILTER",
  MODIFY_SELECTED_USERS: "MODIFY_SELECTED_USERS_ENTITLEMENT_MGMT",
  MODIFY_PREV_ABILITATIONS: "MODIFY_PREV_ABILITATIONS",
  MODIFY_ADDED_ABILITATIONS: "MODIFY_ADDED_ABILITATIONS",
  MODIFY_ADDED_BR: "MODIFY_ADDED_BR",
  MODIFY_DELETED_ABILITATIONS: "MODIFY_DELETED_ABILITATIONS",
  MODIFY_REMOVED_BR: "MODIFY_REMOVED_BR",
  MODIFY_MODIFIED_ABILITATIONS: "MODIFY_MODIFIED_ABILITATIONS",
  MODIFY_TOTAL_ABILITATIONS: "MODIFY_TOTAL_ABILITATIONS",
  MODIFY_TOTAL_ABILITATIONS_BR: "MODIFY_TOTAL_ABILITATIONS_BR",
  MODIFY_COMMENT: "MODIFY_COMMENT",
  OFFICE_REQUEST: "OFFICE_REQUEST",
  OFFICE_REQUEST_SUCCESS: "OFFICE_REQUEST_SUCCESS",
  OFFICE_REQUEST_FAILURE: "OFFICE_REQUEST_FAILURE",
  PAGINATED_USER_REQUEST: "PAGINATED_USER_REQUEST",
  PAGINATED_USER_REQUEST_SUCCESS: "PAGINATED_USER_REQUEST_SUCCESS",
  PAGINATED_USER_REQUEST_FAILURE: "PAGINATED_USER_REQUEST_FAILURE",
  USER_REQUEST: "USER_REQUEST",
  USER_REQUEST_SUCCESS: "USER_REQUEST_SUCCESS",
  USER_REQUEST_FAILURE: "USER_REQUEST_FAILURE",

  OFFICE_PAGINATED_ENTITLEMENT_REQUEST: "OFFICE_PAGINATED_ENTITLEMENT_REQUEST",
  OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS:
    "OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS",
  OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE:
    "OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE",
  OFFICE_PAGINATED_BR_REQUEST: "OFFICE_PAGINATED_BR_REQUEST",
  OFFICE_PAGINATED_BR_REQUEST_SUCCESS: "OFFICE_PAGINATED_BR_REQUEST_SUCCESS",
  OFFICE_PAGINATED_BR_REQUEST_FAILURE: "OFFICE_PAGINATED_BR_REQUEST_FAILURE",

  OFFICE_ENTITLEMENT_REQUEST: "OFFICE_ENTITLEMENT_REQUEST",
  OFFICE_ENTITLEMENT_REQUEST_SUCCESS: "OFFICE_ENTITLEMENT_REQUEST_SUCCESS",
  OFFICE_ENTITLEMENT_REQUEST_FAILURE: "OFFICE_ENTITLEMENT_REQUEST_FAILURE",
  ENTITLEMENT_REQUEST: "ENTITLEMENT_REQUEST",
  ENTITLEMENT_REQUEST_SUCCESS: "ENTITLEMENT_REQUEST_SUCCESS",
  ENTITLEMENT_REQUEST_FAILURE: "ENTITLEMENT_REQUEST_FAILURE",
  CREATE_REQUEST: "CREATE_REQUEST",
  CREATE_REQUEST_SUCCESS: "CREATE_REQUEST_SUCCESS",
  CREATE_REQUEST_FAILURE: "CREATE_REQUEST_FAILURE",
  RESET_ABILITATIONS: "RESET_ABILITATIONS",
  RESET_STATE: "RESET_STATE",
  BAO_ENTITLEMENT_REQUEST: "BAO_ENTITLEMENT_REQUEST",
  BAO_ENTITLEMENT_REQUEST_SUCCESS: "BAO_ENTITLEMENT_REQUEST_SUCCESS",
  BAO_ENTITLEMENT_REQUEST_FAILURE: "BAO_ENTITLEMENT_REQUEST_FAILURE",
  ENTITLEMENTS_BUSINESS_ROLES_SELECTED: "ENTITLEMENTS_BUSINESS_ROLES_SELECTED",
  ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET:
    "ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET",
  SET_EXISTING_SAME_DB: "SET_EXISTING_SAME_DB",
  SET_IS_COMMENT_COMPULSORY_ACTION: "SET_IS_COMMENT_COMPULSORY_ACTION",
  SOD_CONFLICTS: "SOD_CONFLICTS",
  SOD_CONFLICTS_SUCCESS: "SOD_CONFLICTS_SUCCESS",
  SOD_CONFLICTS_FAILURE: "SOD_CONFLICTS_FAILURE",
  RESET_SOD_CONFLICTS: "RESET_SOD_CONFLICTS",
  MODIFY_SOD_COMMENT: "MODIFY_SOD_COMMENT",
  ABILITATION_MANAGEMENT_SET_START_END_DATE:
    "ABILITATION_MANAGEMENT_SET_START_END_DATE",
};

export const modifySodComment = (sodComment: string) => ({
    type: actionTypes.MODIFY_SOD_COMMENT,
    sodComment,
  });

export const selectOffice = (id: string) => ({
  type: actionTypes.SELECT_OFFICE,
  id,
});

export const entitlementsListBusinessRolesSelectedReset = () => ({
  type: actionTypes.ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET,
});

export const businessRolesSelected = (
  payload: IEntitlementsBRItem[] | IBREntitlementsItem[]
) => ({
  type: actionTypes.ENTITLEMENTS_BUSINESS_ROLES_SELECTED,
  payload,
});

export const modifyIsSelfSelected = (isSelfSelected: boolean) => ({
  type: actionTypes.MODIFY_SELF_SELECTED,
  isSelfSelected,
});

export const modifyDelegator = (code: string) => ({
  type: actionTypes.MODIFY_DELEGATOR,
  code,
});

export const modifyShowAdvancedFilter = (showAdvancedFilter: boolean) => ({
  type: actionTypes.MODIFY_SHOW_ADVANCED_FILTER,
  showAdvancedFilter,
});

export const modifySelectedUsers = (selectedUsers: IUserItem[]) => ({
  type: actionTypes.MODIFY_SELECTED_USERS,
  selectedUsers,
});

export const modifyPrevAbilitations = (
  prevAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.MODIFY_PREV_ABILITATIONS,
  prevAbilitations,
});

export const modifyAddedAbilitations = (
  addedAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.MODIFY_ADDED_ABILITATIONS,
  addedAbilitations,
});

export const modifyAddedBR = (addedBR: IBRItem[]) => ({
  type: actionTypes.MODIFY_ADDED_BR,
  addedBR,
});

export const modifyDeletedAbilitations = (
  deletedAbilitations: IEntitlementsAndBRItem[]
) => ({
  type: actionTypes.MODIFY_DELETED_ABILITATIONS,
  deletedAbilitations,
});

export const modifyRemovedBR = (removedBR: IBRRequestAndItem[]) => ({
  type: actionTypes.MODIFY_REMOVED_BR,
  removedBR,
});

export const modifyModifiedAbilitations = (
  modifiedAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.MODIFY_MODIFIED_ABILITATIONS,
  modifiedAbilitations,
});

export const modifyTotalAbilitations = (
  totalAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.MODIFY_TOTAL_ABILITATIONS,
  totalAbilitations,
});

export const modifyTotalAbilitationsBR = (
  totalAbilitations: IBRRequestItem[]
) => ({
  type: actionTypes.MODIFY_TOTAL_ABILITATIONS_BR,
  totalAbilitations,
});

export const modifyComment = (comment: string) => ({
  type: actionTypes.MODIFY_COMMENT,
  comment,
});

export const officeRequest = () => ({
  type: actionTypes.OFFICE_REQUEST,
});

export const officeRequestSuccess = (payload: IOfficeItemProps[]) => ({
  type: actionTypes.OFFICE_REQUEST_SUCCESS,
  payload,
});

export const officeRequestFailure = (err: Error) => ({
  type: actionTypes.OFFICE_REQUEST_FAILURE,
  err,
});
export const paginatedUserRequest = (payload: any) => ({
  type: actionTypes.PAGINATED_USER_REQUEST,
  payload,
});

export const paginatedUserRequestSuccess = (payload: IUserItem[]) => ({
  type: actionTypes.PAGINATED_USER_REQUEST_SUCCESS,
  payload,
});

export const paginatedUserRequestFailure = (err: Error) => ({
  type: actionTypes.PAGINATED_USER_REQUEST_FAILURE,
  err,
});
export const userRequest = (id: string | number) => ({
  type: actionTypes.USER_REQUEST,
  id,
});

export const userRequestSuccess = (payload: IUserItem[]) => ({
  type: actionTypes.USER_REQUEST_SUCCESS,
  payload,
});

export const userRequestFailure = (err: Error) => ({
  type: actionTypes.USER_REQUEST_FAILURE,
  err,
});

export const officePaginatedEntitlementRequest = (payload: {
  userCodes: string[];
  ou?: string;
  entitlementName?: string;
  entitlementDescription?: string;
  applicationName?: string;
  applicationDescription?: string;
  identitySystemId?: string;
  pageNumber: number;
  pageSize: number;
}) => ({
  type: actionTypes.OFFICE_PAGINATED_ENTITLEMENT_REQUEST,
  payload,
});
export const officePaginatedEntitlementRequestSuccess = (payload: any[]) => ({
  type: actionTypes.OFFICE_PAGINATED_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});
export const officePaginatedEntitlementRequestFailure = (err: Error) => ({
  type: actionTypes.OFFICE_PAGINATED_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const officePaginatedBrRequest = (payload: {
  userCodes: string[];
  ou?: string;
  application?: string;
  applicationDescription?: string;
  pageNumber: number;
  pageSize: number;
}) => ({
  type: actionTypes.OFFICE_PAGINATED_BR_REQUEST,
  payload,
});
export const officePaginatedBrRequestSuccess = (payload: any[]) => ({
  type: actionTypes.OFFICE_PAGINATED_BR_REQUEST_SUCCESS,
  payload,
});
export const officePaginatedBrRequestFailure = (err: Error) => ({
  type: actionTypes.OFFICE_PAGINATED_BR_REQUEST_FAILURE,
  err,
});

export const officeEntitlementRequest = (id: string | number) => ({
  type: actionTypes.OFFICE_ENTITLEMENT_REQUEST,
  id,
});

export const officeEntitlementRequestSuccess = (
  payload: IEntitlementItem[]
) => ({
  type: actionTypes.OFFICE_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const officeEntitlementRequestFailure = (err: Error) => ({
  type: actionTypes.OFFICE_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const entitlementRequest = (selectedUsers: IUserItem[]) => ({
  type: actionTypes.ENTITLEMENT_REQUEST,
  selectedUsers,
});

export const entitlementRequestSuccess = (payload: IEntitlementItem[]) => ({
  type: actionTypes.ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const entitlementRequestFailure = (err: Error) => ({
  type: actionTypes.ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const createRequest = (abilitationObj: FormData) => ({
  type: actionTypes.CREATE_REQUEST,
  abilitationObj,
});

export const createRequestSuccess = () => ({
  type: actionTypes.CREATE_REQUEST_SUCCESS,
});

export const createRequestFailure = (err: Error) => ({
  type: actionTypes.CREATE_REQUEST_FAILURE,
  err,
});

export const resetAbilitations = () => ({
  type: actionTypes.RESET_ABILITATIONS,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE,
});

export const baoEntitlementRequest = (id: string | number) => ({
  type: actionTypes.BAO_ENTITLEMENT_REQUEST,
  id,
});

export const baoEntitlementRequestSuccess = (payload: IRequestBR[]) => ({
  type: actionTypes.BAO_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const setExistingSameDb = (payload: any[]) => ({
  type: actionTypes.SET_EXISTING_SAME_DB,
  payload,
});

export const setIsCommentCompulsoryAction = (payload: boolean) => ({
  type: actionTypes.SET_IS_COMMENT_COMPULSORY_ACTION,
  payload,
});

export const baoEntitlementRequestFailure = (error: Error) => ({
  type: actionTypes.BAO_ENTITLEMENT_REQUEST_FAILURE,
  error,
});

export const sodConflictsAction = (payload: IFetchSODConflictsBody) => ({
  type: actionTypes.SOD_CONFLICTS,
  payload,
});

export const sodConflictsActionSuccess = (payload: any[]) => ({
  type: actionTypes.SOD_CONFLICTS_SUCCESS,
  payload,
});

export const sodConflictsActionFailure = (err: Error) => ({
  type: actionTypes.SOD_CONFLICTS_FAILURE,
  err,
});

export const resetSodConflictsAction = () => ({
  type: actionTypes.RESET_SOD_CONFLICTS,
});

export const setStartEndDate = (
  startDate: number,
  endDate: number,
  id: string | number
) => ({
  type: actionTypes.ABILITATION_MANAGEMENT_SET_START_END_DATE,
  payload: {
    startDate,
    endDate,
    id,
  },
});
